<template>
  <div class="card_flex">
    <div class="filter">
      <fg-input
          v-model="filter.searchword"
          type="text"
          class=""
          placeholder="name group"
          :clearable="true"
          @keyup.enter="search"
      />
      <button
        class="btn btn-success"
        @click="search"
      >
        {{ translate('search') }}
      </button>
    </div>
    <div class="group_list">
      <v-tree style="margin-top: 10px; margin-left: 30px" ref='tree1' @drag-node-end="drag" :canDeleteRoot="true" :data='groupTree' :draggable='true'  :tpl='tpl' />
    </div>
  </div>
</template>

<script>
import GlobalConfirm from "components/UIComponents/Confirm/GlobalConfirm.vue";

export default {
  name: 'SimCardDevicesGroupTree',
  components: {
  },
  data () {
    return {
      new_group: {},
      search_group: [],
      filter:{
        searchword: '',
        group_id: null
      },
    }
  },

  computed: {
    groupTree () {
      return  [{
        expanded: true,
        id: -1,
        label: 'all group',
        name: 'all group',
        children : this.$store.getters.getSimcardDevicesGroupsTree
      }]
    }
  },

  watch: {
    parent_filter(){
      this.filter = this.parent_filter
      this.pre_search()
    },
    filter: {
      deep: true,
      handler() {
        this.$emit("filter", this.filter)
      }
    },
    groupTree () {
      if(this.new_group.id !== undefined) {
        this.$refs.tree1.searchNodes((node) => {
            if (node.id === this.new_group.id) {
              this.choice(node)
              node.searched = true
              this.new_group = {}
            }
          }
        )
      }
    }
  },
  methods: {
    pre_search(){
      this.loading = true
      this.empty = false
      setTimeout(this.search, 100)
    },
    choice (group) {
      if (group.id) this.$emit('filter', {group_id: group.id})
      this.cur_group = group
      this.$emit('choice', group)
    },
    search () {
      if(this.filter.searchword.trim() === '') {
        this.$refs.tree1.searchNodes()
        return true
      }
      this.$refs.tree1.searchNodes((node) => {
        let name = node.name.toLowerCase()
        return name.indexOf(this.filter.searchword.toLowerCase()) !== -1 }
      )
    },

    tpl (...args) {
      let {0: node, 2: parent} = args
      let titleClass = node.selected ? 'node-title' : 'node-title'
      if (node.searched) titleClass += ' node-searched'
      let cross = (parent !== null) ? <span class="mdi mdi mdi-close-box red" onClick={() => this.delete_confirm(node)}
                      title="delete"/> : ''
      return <span>
        <button class="treebtn1" onClick={() => this.add(node)}>+</button>
         <span class={titleClass} domPropsInnerHTML={node.name} onClick={() => {
           if(parent == null) {
             return false
           }
           // this.$refs.tree1.nodeSelected(node)
           this.choice(node)
         }}></span>
        {cross}
      </span>
    },
    clear(){
      this.choice({})
    },

    delete_confirm (node) {
      let t = this.$createElement(GlobalConfirm, {
        props: {
          text: this.translate('group.del') + ' ' + node.name +'?'
        },
        on: {
          close: () => {
            this.$modal.hide('confirm_delete_simcard_devices_group')
          },
          confirm: () => {
            this.delete(node)
            this.$modal.hide('confirm_delete_simcard_devices_group')
          }
        }
      })
      let temp = { render () { return t } }
      this.$modal.show(temp, {}, {height: 'auto', adaptive: true, clickToClose: false, scrollable: true, name: 'confirm_delete_simcard_devices_group'})
    },

    delete (node) {
      this.$http.v1.deleteSimcardGroup({'group_id': node.id}, () => {
        this.global_notify('info', this.translate('group.deleted'))
        this.clear()
        this.$store.dispatch('groupSimcardDevicesUpdate')
      })
    },
    add (node) {
      this.$http.v1.addSimcardGroup({'name': "!new group", 'parent': node.id }, (resp) => {
        this.global_notify('info', this.translate('group.added'))
        this.new_group = resp.data.group
        this.$store.dispatch('groupSimcardDevicesUpdate')
      })
    },
    drag (...args) {
      let {dragNode: dragNode, targetNode: target} = args[0]

      this.$http.v1.updateSimcardGroup({'id': dragNode.id, 'name': dragNode.name, 'parent': target.id}, () => {
        this.global_notify('info', this.translate('group.updated'))
      })
    },
  }
}
</script>

<style lang="scss" scoped>

.card_flex {
  overflow: hidden;
  padding: 10px;
  .filter {
    flex: 1;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
    .form-group{
      margin-bottom: 0;
      width: 80%;
    }
    .btn{
      width: 15%;
    }
  }
  .group_list {
    overflow: auto;
    width: 100%;
    flex: 12;
    border: 1px solid #DCDCDC;
  }
}

@media (max-width: 768px) {
  .card_flex {
    padding: 10px 0;
    .filter {
      .form-group{
        width: 70%;
        margin-right: 10px;
      }
      .btn{
        width: 30%;
      }
    }
    .group_list {
      overflow: auto;
      width: 100%;
      flex: 12;
      border: 1px solid #DCDCDC;
    }
  }
}
</style>
